<template>
  <div class="wrapper">
    <Headers ref="headers" />
    <div class="mainPage1">
      <section class="user-setting">
        <div class="container">
          <div class="container__elem container__elem--12">
            <div class="user-setting__inner">
              <h1 class="user-setting__title">Настройка профиля</h1>
              <form class="user-setting__form" @submit.prevent="saveProfile">
                <div class="user-setting__content">
                  <div class="user-setting__info">
                    <p class="user-setting__info-name">{{ userClone.name + "&nbsp;" + userClone.surname }}</p>
                    <p class="user-setting__info-mail">{{ user.email }}</p>
                  </div>
                  <div class="user-setting__inputs">
                    <div class="user-setting__inputWrapper">
                      <input type="text" class="user-setting__input" v-model="user.name" required
                        @focus="focused.name = true" @blur="focused.name = user.name !== ''" />
                      <label :class="{ floating: focused.name || user.name !== '' }">Имя</label>
                    </div>

                    <div class="user-setting__inputWrapper">
                      <input type="text" class="user-setting__input" v-model="user.surname" required
                        @focus="focused.surname = true" @blur="focused.surname = user.surname !== ''" />
                      <label :class="{ floating: focused.surname || user.surname !== '' }">Фамилия</label>
                    </div>

                    <div class="user-setting__inputWrapper">
                      <input type="text" class="user-setting__input" v-model="user.phone" @input="formatPhone"
                        @focus="focused.phone = true" @blur="validatePhone" placeholder="+7 (___) ___ __ __" />
                      <label :class="{ floating: focused.phone || user.phone !== '' }">Номер телефона</label>
                      <p v-if="phoneError" class="error-message">{{ phoneError }}</p>
                    </div>
                  </div>
                </div>

                <button type="submit" class="user-setting__confirm">Сохранить</button>

                <div v-if="message" :class="['user-setting__message', message.type]">{{ message.text }}</div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footers />
  </div>
</template>

<script>
import axios from "axios";
import Headers from "@/components/Headers.vue";
import Footers from "@/components/Footers.vue";

axios.defaults.headers.common["X-API-KEY"] = "Ha12d-234f_1AUqw-KkoQG-QrtwQ1";

export default {
  name: "UserSettingView",
  components: {
    Headers,
    Footers,
  },
  data() {
    return {
      focused: {
        name: false,
        surname: false,
        phone: false,
      },
      user: {
        name: "Иван",
        surname: "Петров",
        email: "example@gmail.com",
        phone: "+7 ",
      },
      userClone: {
        name: "Иван",
        surname: "Петров",
        email: "example@gmail.com",
        phone: "+7 ",
      },
      phoneError: null,
      message: null,
    };
  },
  methods: {
    async saveProfile() {
      let sendPhone = this.user.phone;
      if (!this.validatePhone()) {
        return;
      } else if (sendPhone == "+7 ") {
        sendPhone = null;
      }
      try {
        await axios.put(
          "/api/pis/v1/user/edit_profile",
          {
            name: this.user.name,
            surname: this.user.surname,
            phone: sendPhone,
          },
          {
            headers: {
              "Content-Type": "application/json",
            }
          }
        );

        this.message = {
          text: "Успешно сохранено!",
          type: "success",
        };

        setTimeout(() => {
          this.message = null;
        }, 5000);

        this.userClone = { ...this.user };
      } catch (error) {
        console.error("Ошибка при сохранении профиля:", error);
        this.message = {
          text: "Ошибка сохранения. Попробуйте еще раз.",
          type: "error",
        };
      }
    },
    formatPhone(event) {
      const input = event.target.value.replace(/\D/g, ""); // Убираем все нецифровые символы
      let formatted = "+7 ";
      if (input.length > 1) formatted += `(${input.slice(1, 4)}`;
      if (input.length >= 5) formatted += `) ${input.slice(4, 7)}`;
      if (input.length >= 8) formatted += ` ${input.slice(7, 9)}`;
      if (input.length >= 10) formatted += ` ${input.slice(9, 11)}`;
      this.user.phone = formatted; // Обновляем значение
    },
    validatePhone() {
      if (!this.user.phone || this.user.phone == "+7 ") {
        this.phoneError = null; // Очищаем ошибку, если поле пустое
        return true;
      }

      const phoneRegex = /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;
      if (!phoneRegex.test(this.user.phone)) {
        this.phoneError = 'Введите номер телефона в формате +7 (777) 777 77 77';
        return false;
      }

      this.phoneError = null;
      return true;
    },
    getUserInfo(userInfo) {
      if (userInfo) {
        this.user = { ...userInfo };
        this.userClone = { ...userInfo };
      } else {
        console.error("Пустые данные для обновления пользователя");
      }
    },
  },
  mounted() {
    const storedUserInfo = localStorage.getItem("userInfo") || sessionStorage.getItem("userInfo");

    if (!storedUserInfo) {
      this.$router.push({ path: "/login" });
    } else {
      try {
        const userInfo = JSON.parse(storedUserInfo);
        this.getUserInfo(userInfo);
      } catch (error) {
        console.error("Ошибка при парсинге userInfo из хранилища:", error);
        this.$router.push({ path: "/login" });
      }
    }
  },
};
</script>

<style>
.user-setting__message {
  margin-top: 16px;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
}

.user-setting__message.success {
  color: #4caf50;
  background-color: #dff0d8;
}

.user-setting__message.error {
  color: #f44336;
  background-color: #f8d7da;
}

.error-message {
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
}
</style>
